<nb-card style="height: 100%;">
  <nb-card-header>
    <h2>Restart Services</h2>
  </nb-card-header>
  <nb-card-body>
    <nb-card >
      <nb-card-header>
      </nb-card-header>
      <nb-card-body [nbSpinner]="serviceLoading">
        <form #restartForm="ngForm" id="restartForm" name="restartForm" style="margin-top: 15px;">
          <div class="row">
            <div class="form-group col-sm-4">
              <div class="kw-input">
                <printer-selector (selectionChanged)="setPrinter($event)" required></printer-selector>
              </div>
            </div>
          </div>
        </form>
      </nb-card-body>
      <nb-card-footer class="row" style="margin-top: 10px;">
        <div [nbSpinner]="submitting" class="col-md-auto d-flex align-items-center">
          <button *ngIf="!submitting" type="submit" mat-raised-button color="primary"
            (click)="restartClicked();">Restart</button>
        </div>
      </nb-card-footer>
    </nb-card>
  </nb-card-body>
</nb-card>